import axios from "axios";
import config from "../shared/config";
import {useOktaAuth} from "@okta/okta-react";

export const toCapitalize = (str) => {
    let lowerStr = str.toLowerCase()
    return lowerStr[0].toUpperCase() + lowerStr.slice(1);
}

export const toCapitalizeSplitStr = (str) => {
    let lowerStr = str.toLowerCase()
    const arr = lowerStr.split(" ");
    const _arr = arr.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    return _arr.join(" ");
}

export const formatDate = (dateStr) => {
    return dateStr.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    })
}

export const useAuthConfig = () => {
    const {authState} = useOktaAuth();
    return axios.create({
        baseURL: config.apiBaseURI,
        headers: {
            Authorization: `Bearer ` + authState.accessToken,
            'content-type': 'application/json',
            'Accept': 'application/json'
        }
    });
}